import React from 'react';
import PropTypes from 'prop-types';
import { RatingBar } from 'site-modules/lease-deals/components/rating-bar/rating-bar';
import { useRatingBar } from 'site-modules/lease-deals/hooks/use-rating-bar/use-rating-bar';

import './lease-deals-value-signal.scss';

const colorRules = [
  { threshold: 1, color: 'orange-30' },
  { threshold: 3, color: 'blue-50' },
  { threshold: 5, color: 'green-60' },
];

export function LeaseDealsValueSignal({
  value,
  hideRatingNumber = false,
  numeratorClassName = undefined,
  denominatorClassName = undefined,
  createBarHeight = undefined,
}) {
  const { activeColor, bars } = useRatingBar({ value, createBarHeight, colorRules });
  const { rating, maxRating } = value;

  return (
    <div className="lease-deals-value-signal d-flex gap-0_5 h-1">
      <RatingBar activeColor={activeColor} bars={bars} rating={rating} barWidth={5} />
      {!hideRatingNumber && (
        <div className="d-flex align-items-end">
          <span className={numeratorClassName || `size-24 lh-1 fw-bold text-${activeColor}`}>{rating}</span>
          <span className={denominatorClassName || `size-16 lh-1 text-${activeColor}`}>/{maxRating}</span>
        </div>
      )}
    </div>
  );
}

LeaseDealsValueSignal.propTypes = {
  value: PropTypes.shape({ rating: PropTypes.number, maxRating: PropTypes.number }).isRequired,
  hideRatingNumber: PropTypes.bool,
  numeratorClassName: PropTypes.string,
  denominatorClassName: PropTypes.string,
  createBarHeight: PropTypes.func,
};
